<!--
Event manager

Uses an API from the event manager plugin to get event or instance availability & eligibility

Works in three steps:
	1) Go to the vue store and request the availability data
		- this done in the vue store so if another component has already requested the data, we dont have to make another api call
	2) Use that data to calculate availability & eligibility, and set them as strings
	3) When both functions are done, we can run any other function
		- in boiler this sets the button text/state/url
		- this is set in a watch function
-->
<template>
	<a
		:href="href"
		v-html="text"
		:class="[buttonClass, 'o-button']"
		:disabled="disabled"
		@click.prevent="buttonClick"
	></a>
</template>
<script>
export default {
	name: "emButton",

	data: function () {
		return {
			text: this.$props.overrides.buttonDefaultText,
			buttonClass: "",
			disabled: false,
			href: this.$props.overrides.buttonDefaultUrl,
		};
	},

	props: {
		dataReady: {
			type: Boolean,
			default: false,
		},
		availability: {
			type: String,
		},
		eligibility: {
			type: String,
		},
		overrides: {
			type: Object,
		},
	},

	async mounted() {},

	methods: {
		setButtonAttributes() {
			const self = this;

			//We run this from low override priority to high - constantly checking for override data is annoying otherwise
			//console.log(self.eligibility, self.availability, self.overrides);
			//if E = public
			if (self.eligibility == "public") {
				//if A = Available
				if (self.availability == "available") {
					self.text = "Book now";
					self.disabled = false;
					(self.href = self.$props.overrides.buttonDefaultUrl),
						(self.buttonClass = self.buttonClass.replace(
							" o-button--disabled",
							"",
						));
				}
				//if A = Low availability
				if (self.availability == "lowAvailability") {
					self.text = "Book now";
					self.disabled = false;
					(self.href = self.$props.overrides.buttonDefaultUrl),
						(self.buttonClass = self.buttonClass.replace(
							" o-button--disabled",
							"",
						));
				}
				//if A = Selling fast
				if (self.availability == "sellingFast") {
					self.text = "Book now";
					self.disabled = false;
					(self.href = self.$props.overrides.buttonDefaultUrl),
						(self.buttonClass = self.buttonClass.replace(
							" o-button--disabled",
							"",
						));
				}
			}
			//if E = members
			else if (self.eligibility == "membersOnly") {
				self.text = "Members Only";
				self.disabled = false;
				(self.href = self.$props.overrides.buttonDefaultUrl),
					(self.buttonClass = self.buttonClass.replace(
						" o-button--disabled",
						"",
					));
			}
			//if E = coming soon
			else if (self.eligibility == "comingSoon") {
				self.text = "Coming soon";
				self.href = "#";
				self.disabled = true;
				self.buttonClass = self.buttonClass + " o-button--disabled";
			}

			//if A = sold out
			if (self.availability == "soldOut") {
				self.text = "Sold out";
				self.href = "#";
				self.disabled = true;
				self.buttonClass = self.buttonClass + " o-button--disabled";
			}

			//if A = Access availability
			if (self.availability == "accessAvailability") {
				self.text = "Limited Availability";
			}

			if (self.availability == "cancelled") {
				self.text = "Cancelled";
				self.href = "#";
				self.disabled = true;
				self.buttonClass = self.buttonClass + " o-button--disabled";
			}

			switch (self.overrides.buttonPreset) {
				case "hideButton":
					self.buttonClass = "o-button--hidden";
					break;

				case "soldOut":
					self.text = "Sold out";
					self.href = "#";
					self.disabled = true;
					self.buttonClass = self.buttonClass + " o-button--disabled";
					break;

				case "comingSoon":
					self.text = "Coming soon";
					self.href = "#";
					self.disabled = true;
					self.buttonClass = self.buttonClass + " o-button--disabled";
					break;

				case "postponed":
					self.text = "Postponed";
					self.href = "#";
					self.disabled = true;
					self.buttonClass = self.buttonClass + " o-button--disabled";
					break;

				case "cancelled":
					self.text = "Cancelled";
					self.href = "#";
					self.disabled = true;
					self.buttonClass = self.buttonClass + " o-button--disabled";
					break;

				case "accessOnly":
					self.text = "Access only";
					self.href = self.$props.overrides.buttonDefaultUrl;
					self.disabled = false;
					self.buttonClass = self.buttonClass.replace(
						" o-button--disabled",
						"",
					);
					break;

				case "custom":
					self.text = self.overrides.buttonTextOverride
						? self.overrides.buttonTextOverride
						: self.text;
					self.href = self.overrides.buttonHrefOverride
						? self.overrides.buttonHrefOverride
						: self.href;
					if (
						self.overrides.buttonStateOverride == "disabled" ||
						self.overrides.buttonStateOverride == "enabled"
					) {
						self.disabled =
							self.overrides.buttonStateOverride == "enabled" ? false : true;
						self.buttonClass =
							self.overrides.buttonStateOverride == "enabled"
								? self.buttonClass.replace("o-button--disabled", "")
								: self.buttonClass + " o-button--disabled";
					} else if (self.overrides.buttonStateOverride == "hidden") {
						self.buttonClass = "o-button--hidden";
					}
					break;
			}
		},
		buttonClick() {
			const self = this;

			switch (self.eligibility) {
				case "comingSoon":
					break;

				case "membersOnly":
					self.$emit("checkEligibility", self.href);
					break;

				default:
					window.location.href = self.href;
					break;
			}
		},
	},

	watch: {
		dataReady(value) {
			if (value) {
				this.setButtonAttributes();
			}
		},
	},
};
</script>
